import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { Service } from "../../shared/services/service";
import { Funcoes } from "../../funcoes";

@Injectable()
export class ExamesTesteSoproService extends Service {

  protected url: string = this.dominio + "/adm/exames/teste-sopro/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  getPdfUrl(id: string | number, lang?: string): string {
    let token = localStorage.getItem('token');
    let url = this.dominio + '/adm/exames/teste-sopro/' + id + '/pdf';
    if (lang) {
      url += '/' + lang;
    }
    return url + '/?tk=' + token;
  }

  getFotos(id: string | number) {
    let headers = this.getHeaderLogado();
    return this.http.get(this.url + id + '/fotos/', { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  apagarFoto(idTeste: string | number, idFoto: string | number) {
    let headers = this.getHeaderLogado();
    return this.http.delete(this.url + idTeste + '/fotos/' + idFoto + '/', { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  girarFoto(idTeste: string | number, idFoto: string | number) {
    let headers = this.getHeaderLogado();
    return this.http.put(this.url + idTeste + '/fotos/' + idFoto + '/girar/', JSON.stringify({}), { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  ordenaFotos(idTeste: string | number, fotos: any[]) {
    let headers = this.getHeaderLogado();
    return this.http.put(this.url + idTeste + '/ordena-fotos/', JSON.stringify(fotos), { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  baixarFotosZip(idTeste: string | number) {
    let headers = this.getHeaderLogado();
    return this.http.get(this.url + idTeste + '/fotos/zip/', { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  getPdfs(idTeste: string | number) {
    let headers = this.getHeaderLogado();
    return this.http.get(this.url + idTeste + '/pdfs/', { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  apagarPdf(idTeste: string | number, idPdf: string | number) {
    let headers = this.getHeaderLogado();
    return this.http.delete(this.url + idTeste + '/pdfs/' + idPdf + '/', { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  ordenaPdfs(idTeste: string | number, pdfs: any[]) {
    let headers = this.getHeaderLogado();
    return this.http.put(this.url + idTeste + '/ordena-pdfs/', JSON.stringify(pdfs), { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  setStatus(idTeste: string | number, idStatus: string | number, notifica = true) {
    let headers = this.getHeaderLogado();
    let url = this.url + idTeste + '/status/' + idStatus + '/';

    if (!notifica) {
      url += 'nao-notifica/';
    }

    return this.http.put(url, {}, { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  enviarTesteParaCliente(idTeste: string | number) {
    let headers = this.getHeaderLogado();
    return this.http.post(this.url + idTeste + '/notificar', {}, { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  enviarTesteParaEmailEspecifico(idTeste: string | number, email: string) {
    let headers = this.getHeaderLogado();
    return this.http.post(this.url + idTeste + '/notificar-com-email', JSON.stringify({ email }), { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/exames/teste-sopro/exames-teste-sopro.service.ts